import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import GoablTempalate from '../../components/GoablTempalate'
import { history } from 'ice';

const { Cell } = ResponsiveGrid;


function getObj(){
   
  return {
    service:'communityRules', 
    name:"規範",
    display :false
  }


}
const CommunityRules = () => (
  
 
  <ResponsiveGrid gap={20}>
  
    <Cell colSpan={12}>
      <PageHeader
        title="社區規範列表"
   
        breadcrumbs={[
          {
            name: '社區規範',
          },
          {
            name: '社區規範列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>

      <GoablTempalate data={getObj()}/>
    
    </Cell>
  </ResponsiveGrid>
);

export default CommunityRules;
